export enum FieldType {
  DATE = 'DATE',
  VARIABLE_TEXT = 'VARIABLE_TEXT', // text is taken by Quill
  BOOLEAN = 'BOOLEAN',
  IDENTITY = 'IDENTITY',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}
